import { z } from "zod";
import elementValueList from "./elementValueList";

export default z
  .object({
    alloyFactor: z
      .number()
      .multipleOf(0.01)
      .gte(0.8)
      .lte(1.3)
      .describe("Alloy factor <0.8, 1.30>"),
    analysis: elementValueList,
    carbideLimit: z
      .number()
      .int()
      .gte(0)
      .lte(999)
      .describe("Carbide limit <0, 999>"),
    carbonContent: z
      .number()
      .multipleOf(0.01)
      .gte(0)
      .lte(1)
      .describe("Carbon content <0, 1> %wt"),
    co: z.number().gte(0).lte(100).describe("CO content"),
    customerMaterialId: z.number().int().describe("Customer material id?"),
    endTemperature: z
      .number()
      .int()
      .gte(0)
      .lte(300)
      .describe("End temperature <0, 300> [C]"),
    grainSize: z
      .number()
      .int()
      .gte(2)
      .lte(12)
      .describe("ASTM grain size number, G <2, 12>"),
    h2: z.number().gte(0).lte(100).describe("H2 content"),
    legFactorN: z.number().gte(0).describe("Leg factor N"),
    quenchingIntensity: z
      .number()
      .multipleOf(0.01)
      .gte(0.05)
      .lte(5)
      .describe("Quenching intensity <0.05, 5>"),
    representativeDiameter: z
      .number()
      .multipleOf(0.01)
      .gte(5)
      .lte(500)
      .describe("Representative diameter <5, 500> [mm]"),
    requiredHardness: z
      .number()
      .int()
      .gte(0)
      .lte(1000)
      .describe("Required hardness <0, 1000>[HV?]"),
    specialNitrides: z.number().gte(0).describe("Special Nitrides"),
    targetSurfC: z.number().gte(0).describe("Target surface carbon "),
    temperature: z
      .number()
      .int()
      .gte(0)
      .lte(2000)
      .describe("Temperature <0, 2000> [C]"),
  })
  .describe(
    "BATCH Recipe material. Note - it is not reference to material in PT98 (which is material.customerMaterialId), but general recipe material properties."
  );
